"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var core_1 = require("@material-ui/core");
var empty_graphic_new_svg_1 = __importDefault(require("@assets/components/directory/empty-search-graphic/empty-graphic-new.svg"));
var AppMargins_1 = require("../../../app/components/AppMargins");
var useStyles = core_1.makeStyles(function (theme) {
    var _a;
    return core_1.createStyles({
        root: (_a = {
                display: 'flex',
                flexDirection: 'column',
                marginTop: theme.spacing(8),
                marginBottom: theme.spacing(8),
                paddingTop: theme.spacing(4),
                alignItems: 'center',
                backgroundColor: 'white'
            },
            _a[theme.breakpoints.up('md')] = {
                marginTop: theme.spacing(10),
                paddingTop: theme.spacing(6),
            },
            _a),
        emptyStateGraphic: {
            marginTop: '48px',
            marginBottom: '76px',
        },
        emptyStateGraphicImg: {
            maxWidth: 200,
        },
        emptyStateBodyText: {
            marginTop: '8px',
            textAlign: 'center',
            padding: '10px',
        },
    });
});
/**
 * @component Default display component in place of search result.
 */
var EmptyStateGraphic = function () {
    var t = react_i18next_1.useTranslation().t;
    var classes = useStyles();
    var theme = core_1.useTheme();
    var isMobileView = core_1.useMediaQuery(theme.breakpoints.down('sm'));
    return (react_1.default.createElement(AppMargins_1.ApplyAppMargins, null,
        react_1.default.createElement("div", { className: classes.root },
            react_1.default.createElement(core_1.Typography, { variant: isMobileView ? 'h5' : 'h3' }, t('directory.messageHerder')),
            react_1.default.createElement(core_1.Typography, { variant: "body1", className: classes.emptyStateBodyText },
                t('directory.messageBody1'),
                react_1.default.createElement("br", null),
                t('directory.messageBody2'),
                react_1.default.createElement("br", null),
                t('directory.messageBody3')),
            react_1.default.createElement("div", { className: classes.emptyStateGraphic },
                react_1.default.createElement("img", { src: empty_graphic_new_svg_1.default, alt: "empty search graphic", className: classes.emptyStateGraphicImg })))));
};
exports.default = EmptyStateGraphic;
